{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "statistics": "Estadísticas",
    "jurisdictions": "Jurisdicciones",
    "pendingDisbursements": "Desembolsos pendientes",
    "payments": "Pagos",
    "taxpayers": "Contribuyentes",
    "firstPayment": "Primer pago",
    "lastPayment": "Último pago"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "administration-user": {
    "title": {
      "page": "Usuarios",
      "page-taxpayer": "Contribuyentes",
      "page-disable-tfa": "Deshabilitar Doble Factor de Autenticación (2FA)",
      "activation-link-confirmation": "Confirmar enlace de activación"
    },
    "label": {
      "userName": "Nombre de Usuario",
      "department": "Departamento",
      "roles": "Roles",
      "general-information": "Información general",
      "user": "Nuevo usuario",
      "edit-user": "Editar usuario",
      "disabled": "Deshabilitado",
      "email-confirmed": "Correo electrónico confirmado",
      "invitation-sent-at": "Invitación enviada el",
      "invitation-not-sent": "No enviada",
      "locale": "Lenguaje de preferencia",
      "disable": "Deshabilitar",
      "enable": "Habilitar",
      "cancel": "Cancelar",
      "return": "Regresar"
    },
    "button": {
      "send-activation-link": "Enviar enlace de activación",
      "resend-activation-link": "Reenviar enlace de activación"
    },
    "validations": {
      "userName": "Nombre del usuario es requerido"
    },
    "messages": {
      "disableTitle": "Deshabilitar usuario",
      "confirmDisable": "¿Esta seguro que desea deshabilitar este usuario?",
      "confirmEnable": "¿Esta seguro que desea habilitar este usuario?",
      "savedSucessfully": "Salvado satisfactoriamente",
      "enableTitle": "Habilitar usuario",
      "error": "Error",
      "confirmDisableTfaTitle": "Deshabilitar 2FA",
      "confirmDisableTfa": "¿Está seguro que desea deshabilitar el doble factor de autenticación al usuario \"{0}\"?",
      "tfaDisabledSucessfully": "Doble factor de autenticación deshabilitado satisfactoriamente",
      "activation-link-sent": "Enlace de activación enviado",
      "confirm-send-activation-link": "¿Está seguro de que desea enviar un enlace de activación a este usuario?",
      "confirm-resend-activation-link": "¿Está seguro de que desea reenviar el enlace de activación a este usuario?"
    }
  },
  "user-profile": {
    "title": {
      "page": "Perfil de Usuario",
      "change-password": "Cambiar Contraseña"
    },
    "label": {
      "userName": "Nombre de Usuario",
      "name": "Nombre",
      "email": "Correo",
      "locale": "Idioma Preferido",
      "currentPassword": "Contraseña Actual",
      "newPassword": "Nueva Contraseña",
      "repeatPassword": "Repetir Contraseña",
      "change-password": "Cambiar Contraseña",
      "password": "Contraseña"
    },
    "message": {
      "password-changed": "Contraseña modificada satisfactoriamente",
      "profile-updated": "Perfil actualizado satisfactoriamente. Debe hacer login nuevamente para ver los cambios",
      "password": "Actualiza la contraseña de tu cuenta para mantenerla segura"
    }
  },
  "collections": {
    "label": {
      "maximumNumberOfTaxpayers": "Maximum number of taxpayers",
      "durationProcess": "Duración días",
      "descriptionProcess": "Descripción",
      "selectedTaxpayers": "Seleccionados",
      "excludedTaxpayers": "Excluidos",
      "debtDetail": "Ver detalle deuda",
      "lastTaxreturn": "Última declaración",
      "lastPayment": "Último pago",
      "excluded": "Excluido",
      "debtOriginal": "Deuda original",
      "debtFinal": "Deuda final",
      "currentDebt": "Deuda actual",
      "code": "Identificador",
      "taxpayer": "Contribuyente",
      "start": "Inicio",
      "end": "Fin",
      "newCommunication": "Nueva comunicación",
      "typeCommunication": "Canal de comunicación",
      "saveCommunication": "Guardar comunicación",
      "communicationChannelPhone": "Teléfono",
      "communicationChannelMail": "Correo electrónico",
      "process": "Proceso",
      "startProcess": "Inicio de proceso",
      "recoveredDebt": "Deuda recuperada",
      "endProcess": "Fin proceso",
      "timeElapsed": "Promedio de respuesta",
      "countProcess": "Procesos",
      "countEndedProcess": "Finalizados",
      "countInProgressProcess": "En proceso",
      "countTaxpayerProcess": "Contribuyentes",
      "unpaid": "Moroso",
      "noCommunications": "Sin comunicaciones registradas"
    },
    "title": {
      "detailCollection": "Información de pagos",
      "newProcessCollection": "Nuevo proceso de cobranza",
      "selectionTaxpayerProcess": "Selección de contribuyentes",
      "indicators": "Indicadores",
      "taxreturnAndPayments": "Declaraciones y pagos de impuestos",
      "communications": "Comunicaciones",
      "processCollection": "Procesos de cobranza",
      "StatisticQuery": "Periodo de consulta",
      "StatisticQueryResult": "Resultados"
    },
    "status": {
      "started": "Iniciado",
      "ended": "Terminado"
    },
    "messages": {
      "newProcessCreated": "Se creo un nuevo proceso de cobranza con [limit] contribuyentes el cual comenzo el [startDate] y finaliza el [endDate]"
    }
  },
  "management-report": {
    "label": {
      "taxpayerByCountry": "Por País",
      "taxpayerByOperation": "Por Operación",
      "taxpayerAmount": "Por Mes",
      "taxAmount": "Por Impuesto",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta"
    },
    "title": {
      "pageTaxpayer": "Contribuyentes",
      "pageTaxreturn": "Declaraciones",
      "pagePayment": "Pagos"
    },
    "validations": {
      "dateRequired": "Esta fecha es requerida",
      "dateToGreaterThan": "La fecha debe ser mayor a la Fecha Desde",
      "dateLessThreeMonths": "La fecha deber ser menor a 12 meses desde la Fecha Desde"
    }
  },
  "common": {
    "label": {
      "valueType": "Tipo de valor",
      "theme": "Tema",
      "feedback": "Comentarios",
      "logout": "Salir",
      "print": "Imprimir",
      "phoneNumberArea": "Area",
      "newRecord": "Nuevo",
      "editRecord": "Actualizar",
      "current-user": "Usuario actual",
      "user-profile": "Perfil de usuario",
      "name": "Nombre",
      "search": "Buscar",
      "clean": "Limpiar",
      "create": "Nuevo",
      "ok": "Aceptar",
      "next": "Siguiente",
      "cancel": "Cancelar",
      "back": "Atrás",
      "edit": "Editar",
      "actions": "Acciones",
      "selectAction": "Seleccione acción",
      "send": "Enviar",
      "close": "Cerrar",
      "add": "Agregar",
      "email": "Correo",
      "phoneNumber": "Teléfono",
      "id": "Id",
      "password": "Contraseña",
      "state": "Deshabilitado",
      "translation": "Traducción",
      "language": "Idioma",
      "value": "Valor",
      "translatable": "Traducible",
      "politicalDivision": "División Política",
      "department": "Departamento / Provincia / Estad",
      "city": "Ciudad",
      "zipCode": "Código Postal",
      "cellPhone": "Celular",
      "personType": "Tipo de Persona",
      "businessName": "Nombre o razón social",
      "taxpayerName": "Nombre o razón social",
      "tradeName": "Nombre comercial",
      "address": "Dirección comercial",
      "country": "País",
      "localization": "Ubicación",
      "website": "Sitio Web",
      "fileSearch": "Subir Archivo",
      "fileRequirements": "PDF · Máx. 9.6 MB",
      "fileUploading": "Subiendo...",
      "fileUploaded": "Cargado",
      "fileUploadError": "No se pudo cargar el archivo",
      "fileSelect": "Seleccionar",
      "fileReplace": "Reemplazar",
      "fileRemove": "Quitar",
      "fileRemoving": "Eliminando...",
      "fileRemoveError": "No se pudo eliminar el archivo",
      "fileDownload": "Descargar Archivo",
      "noFileSelected": "Sin Archivo Elegido",
      "dateFrom": "Fecha desde",
      "dateTo": "Fecha hasta",
      "noFound": "No hay ningún resultado",
      "taxReturnCurrency": "Moneda Declaración",
      "page-showing": "Mostrando",
      "page-to": "a",
      "page-of": "de",
      "page-entries": "registros",
      "loading": "Cargando...",
      "error": "Error",
      "unableToLoad": "No se pudieron cargar los datos. Inténtelo de nuevo.",
      "retry": "Reintentar",
      "currency": "Moneda",
      "paymentMethod": "Método de pago",
      "attachment": "Adjunto",
      "paymentReference": "Información complementaria",
      "supportDocument": "Documento de soporte",
      "payment": "Pago",
      "backToHome": "Volver al inicio",
      "createdBy": "Creado por",
      "bank": "Banco",
      "bankInformation": "Información bancaria",
      "excel": "Excel",
      "days": {
        "monday": "Lu",
        "tuesday": "Ma",
        "wednesday": "Mi",
        "thursday": "Ju",
        "friday": "Vie",
        "saturday": "Sá",
        "sunday": "Do"
      },
      "months": {
        "january": "Enero",
        "february": "Febrero",
        "march": "Marzo",
        "april": "Abril",
        "may": "Mayo",
        "june": "Junio",
        "july": "Julio",
        "august": "Agosto",
        "september": "Septiembre",
        "october": "Octubre",
        "november": "Noviembre",
        "december": "Diciembre"
      },
      "type": "Tipo",
      "numeric": "Numérica",
      "date": "Fecha",
      "list": "Lista",
      "text": "Texto",
      "header": "Cabecera",
      "description": "Descripción",
      "ommited": "Omisos",
      "all": "Todos",
      "see": "Mostrar",
      "filters": "Filtros"
    },
    "descriptions": {
      "taxReturnCurrency": "Moneda que se usará para las declaraciones",
      "can-access": "Permite acceso a",
      "contactTaxIdNumber-tax": "Número de identificación tributario del contacto en el país de residencia"
    },
    "button": {
      "add": "Agregar",
      "edit": "Editar",
      "find": "Buscar",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "save": "Guardar",
      "clean": "Limpiar",
      "new": "Nuevo",
      "show": "Ver",
      "download": "Descargar",
      "file": "Adjunto",
      "previous": "Anterior",
      "next": "Siguiente",
      "send": "Enviar",
      "translate": "Traducciones",
      "return": "Volver",
      "continue": "Continuar",
      "newVersion": "Nueva Versión"
    },
    "dialog": {
      "dialog-error": "Errores",
      "table-title-header": "Mensajes",
      "warning-title": "Atención"
    },
    "messages": {
      "error-500": "Ocurrió un error en el servidor, por favor contacte al administrador.",
      "fileUpload": "El archivo ha sido subido de forma exitosa",
      "savedSucessfully": "Almacenado de forma exitosa",
      "deletedSucessfully": "Eliminado de forma exitosa",
      "pleaseWait": "Por favor espere",
      "nofileContent": "El archivo no tiene contenido",
      "errorMessageSystem": "Parámetro '${code}' no fue encontrado en el catálogo",
      "warningInactiveSession": "Atención: No se ha detectado actividad en un tiempo. En 1 minuto se cerrará la sesión si aún no se detecta actividad",
      "sessionIdleCountdown": "Su sesión se cerrará en {{count}} segundos.",
      "closingSession": "Cerrando Sesión ...",
      "confirm": "¿Estas seguro que quieres realizar esta acción?",
      "uploadProcessing": "Se ha cargado la información y esta siendo procesada, se le notificará una vez haya terminado de procesarse.",
      "messageSent": "Mensaje enviado con éxito"
    },
    "validations": {
      "nameRequired": "El campo Nombre es requerido",
      "fieldRequired": "El campo es requerido",
      "numbersAndLetters": "Sólo números y letras",
      "email": "Correo inválido",
      "minStringValue": "Campo debe ser mínimo {{min}} caracteres",
      "maxStringValue": "Campo debe ser máximo {{max}} caracteres",
      "minNumberValue": "Valor del campo debe ser mínimo {{min}}",
      "maxNumberValue": "Valor del campo debe ser máximo {{max}}"
    },
    "languages": {
      "spanish": "Spanish (Spain)",
      "english": "English (United States)"
    },
    "taxpayer-request-types": {
      "enroll": "Registro",
      "update": "Actualización",
      "unsubscribe": "De baja"
    },
    "taxpayer-request-states": {
      "pending": "Pendiente",
      "pending_additional_information": "Pendiente por Información Adicional",
      "approved": "Aprobada",
      "rejected": "Rechazada"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Rectificativa"
    },
    "taxreturn-status": {
      "pending": "Pendiente",
      "accepted": "Aceptada",
      "approved": "Aprobada",
      "rejected": "Rechazada",
      "reconciled": "Conciliado"
    },
    "yes-no": {
      "yes": "Sí",
      "no": "No"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Buzon"
    },
    "label": {
      "message": "Mensaje",
      "messages": "Mensajes",
      "read": "Leido",
      "inboxDate": "Fecha",
      "ok": "SI",
      "no": "NO"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconectando",
      "reconected": "Reconectado"
    }
  },
  "non-compliances": {
    "label": {
      "period": "Periodo",
      "expirationDate": "Fecha vencimiento",
      "NotificationDate": "Fecha notificación",
      "presentationDate": "Fecha presentación",
      "wait": "Espera",
      "penalty": "Penalidad",
      "declarationAmount": "Monto declaración",
      "paymentAmount": "Monto de pago",
      "days": "días",
      "countTaxpayerNotified": "Notificaciones",
      "countTaxpayerCompliance": "Cumplidos",
      "compliancePercentage": "Cumplimiento",
      "elapsedTime": "Tiempo promedio",
      "debtGenerated": "Deuda generada"
    },
    "title": {
      "nonCompliancesTax": "Incumplimiento por impuesto",
      "nonCompliances": "Incumplimientos",
      "nonCompliancesPayments": "Pagos pendientes",
      "StatisticQuery": "Periodo de consulta",
      "StatisticQueryResult": "Resultados"
    }
  },
  "operations-economy-activity": {
    "title": {
      "page": "Actividad Económica"
    },
    "label": {
      "code": "Código",
      "name": "Nombre",
      "description": "Descripción",
      "newButton": "Nuevo",
      "saveButton": "Guardar"
    },
    "header": {
      "code": "Código",
      "name": "Nombre",
      "description": "Descripción",
      "actions": "Acciones"
    },
    "button": {
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "save": "Guardar",
      "search": "Buscar",
      "new": "Nuevo",
      "clean": "Limpiar",
      "ok": "Aceptar"
    },
    "validations": {
      "codeRequired": "El código es requerido",
      "nameRequired": "El nombre es requerido",
      "descriptionRequired": "La descripción es requerida"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿ Está seguro de eliminar esta información ?",
      "deletedSucessfully": "Se ha eliminado con éxito",
      "savedSucessfully": "Información almacenada",
      "error": "Error"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Tipo de catálogo",
      "catalog": "Catálogo "
    },
    "label": {
      "type": "Tipo",
      "name": "Nombre",
      "description": "Descripción",
      "field": "Campo",
      "label": "Etiqueta",
      "parent": "Padre",
      "newCatalogType": "nuevo tipo de catálogo",
      "newCatalog": "Nuevo catálogo",
      "code": "Código ",
      "addDefinition": "Añadir definición",
      "newDefinition": "Nueva definición",
      "extaFilds": "Campos adicionales del usuario",
      "addNameTraslation": "Añadir traducción"
    },
    "validations": {
      "exists": "El registro ya existe",
      "letterNumberhyphen": "Solo letas, numero y guiones son permitidos"
    },
    "messages": {
      "languageExist": "El lenguaje ya fue añadido"
    }
  },
  "parameters-enviroments": {
    "title": {
      "page-security": "Variables de Entorno (Seguridad)",
      "page-application": "Variables de Entorno (Aplicación)"
    },
    "label": {
      "name": "Nombre",
      "type": "Tipo",
      "value": "Valor",
      "newButton": "Nuevo",
      "saveButton": "Guardar"
    },
    "validations": {
      "nameRequired": "El campo Nombre es requerido",
      "typeRequired": "El campo Tipo es requerido",
      "textValueRequired": "El campo Valor es requerido"
    },
    "messages": {
      "savedSucessfully": "Guardado Satisfactoriamente",
      "error": "Error"
    }
  },
  "home-template": {
    "title": {
      "page-home": "Plantilla página de inicio",
      "page-terms": "Plantilla terminos y condiciones"
    },
    "label": {
      "template": "Plantilla"
    },
    "messages": {
      "savedSucessfully": "Guardado satisfactoriamente"
    }
  },
  "parameters-notification-template": {
    "title": {
      "page-application": "Notificaciones Aplicación",
      "page-security": "Notificaciones Seguridad"
    },
    "label": {
      "template": "Plantilla",
      "emailNotification": "Notificar al correo electrónico",
      "pushNotification": "Notificar el buzon",
      "newTemplate": "Nueva plantilla ",
      "id": "Plantilla id",
      "subject": "Asunto",
      "inbox": "Bandeja",
      "header": "Cabecera",
      "footer": "Pie"
    },
    "validations": {
      "templateRequired": "La plantilla es requerida"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Campos Contribuyente",
      "enabled": "Habilitado"
    },
    "header": {
      "fieldCode": "Código",
      "fieldName": "Nombre",
      "fieldSection": "Sección",
      "actions": "Habilitado"
    },
    "messages": {
      "savedSucessfully": "Información almacenada exitosamente"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Procesando",
      "error": "Error",
      "accepted": "Aceptado",
      "processed": "Procesado"
    },
    "title": {
      "page": "Consulta de informes"
    },
    "label": {
      "reportNumber": "Número de informe",
      "reportType": "Tipo de informe",
      "operations": "tipo de operación",
      "taxpayerNumber": "Ruc",
      "taxpayerName": "Nombre de el contribuyente",
      "registrationDate": "Fecha de registro",
      "period": "periodo",
      "reportName": "Nombre de el informe",
      "record": "Valores",
      "index": "Fila",
      "type": "Tipo",
      "active": "Activo",
      "taxReportState": "Estado"
    }
  },
  "payment-file-status": {
    "processing": "Procesando",
    "error": "Error",
    "pending": "Pendiente",
    "accepted": "Aceptado",
    "rejected": "Rechazado",
    "processed": "Procesado",
    "received": "Recibido"
  },
  "taxreturn-report": {
    "title": {
      "page": "Consulta Declaraciones"
    },
    "label": {
      "nit": "Ruc",
      "taxreturnNumber": "Número Declaración",
      "country": "País",
      "formId": "Nombre de Formulario",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "name": "Nombre Contribuyente",
      "period": "Periodo",
      "periodFrom": "Fecha Desde",
      "periodTo": "Fecha Hasta",
      "active": "Activa",
      "overview": "General",
      "taxreturn": "Declaración",
      "createDate": "Fecha",
      "approve": "Aprobado",
      "comments": "Comentarios"
    },
    "header": {
      "actions": "Acciones",
      "nit": "Ruc",
      "name": "Nombre Contribuyente",
      "taxReturnNumber": "Número Declaración",
      "createDate": "Fecha",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "form": "Formulario",
      "period": "Periodo",
      "active": "Activa",
      "rejectionReason": "Motivo de rechazo"
    },
    "validations": {},
    "messages": {
      "periodMessage": "Para periodos anuales formato AAAA, periodo mensual/trimestral AAAAMM"
    },
    "button": {}
  },
  "penalties": {
    "label": {
      "periodFrom": "Período desde",
      "periodTo": "Período hasta"
    },
    "title": {
      "listPenalties": "Configuración de penalidades"
    }
  },
  "taxreturn-evaluation": {
    "title": {
      "page": "Revisión de Rectificativas",
      "approve": "Aprobar Rectificativa",
      "reject": "Rechazar Rectificativa",
      "dialog-confirm": "Confirmar"
    },
    "label": {
      "nit": "Ruc",
      "taxreturnNumber": "Número Declaración",
      "country": "País",
      "taxId": "Impuesto",
      "taxreturnType": "Tipo Declaración",
      "name": "Número Contribuyente",
      "form": "Formulario",
      "approve": "Aprobar",
      "taxpayer": "Contribuyente",
      "comments": "Comentarios",
      "periodFrom": "Fecha Desde",
      "periodTo": "Fecha Hasta",
      "general-comments": "Comentarios Generales"
    },
    "header": {
      "actions": "Acciones",
      "nit": "Ruc",
      "name": "Nombre Contribuyente",
      "taxReturnNumber": "Número Declaración",
      "form": "Formulario",
      "tax": "Impuesto",
      "taxreturnStatus": "Estado",
      "period": "Periodo",
      "createDate": "Fecha"
    },
    "validations": {},
    "messages": {
      "approved": "Declaración Aprobada",
      "rejected": "Declaración Rechazada",
      "confirm": "¿Estas seguro que quieres realizar esta acción?"
    },
    "button": {
      "reject": "Rechazar",
      "approve": "Aprobar"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Api Keys"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Nueva Llave",
      "expiration": "Fecha de Expiración",
      "your-pat": "Su nuevo Personal Access Token",
      "revoke-token": "Revocar Token"
    },
    "validations": {
      "name": "Nombre del Api Key es requerida",
      "expiration": "Fecha de expiración es requerida"
    },
    "message": {
      "key-created": "Asegúrese de guardarla - no podrá acceder a ella nuevamente.",
      "confirm-revoke": "¿Está seguro que desea revocar el token?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Logs de Eventos",
      "http-title": "Logs HTTP",
      "application": "Aplicación",
      "security": "Seguridad"
    },
    "label": {
      "dateFrom": "Fecha Desde",
      "dateTo": "Fecha Hasta",
      "user": "Usuario",
      "aggregateName": "Nombre Entidad",
      "eventName": "Nombre Evento",
      "httpMethod": "Método Http",
      "httpStatusCode": "Código de estado Http",
      "id": "Id",
      "date": "Fecha",
      "url": "URL",
      "ip": "IP",
      "type": "Tipo de petición",
      "consultation": "Consulta",
      "modification": "Modificación"
    },
    "header": {},
    "validations": {
      "dateRequired": "Esta fecha es requerida",
      "dateToGreaterThan": "La fecha debe ser mayor a la Fecha Desde",
      "dateLessThreeMonths": "La fecha deber ser menor a 3 meses desde la Fecha Desde"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Deshabilitar doble factor de autenticación (2FA)",
      "disable": "Deshabilitar 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "This action only disables 2FA.",
      "alert-2": "Al deshabilitar 2FA no se cambian las llaves usadas en la apps autenticadoras.",
      "alert-3": "Si desea cambiar la llave usada en una app autenticadora usted debe:",
      "alert-4": "reiniciar sus llaves autenticadoras.",
      "success": "2fa ha sido deshabilitado. Puede rehabilitar el 2fa cuando haga setup de una app autenticadora"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configurar app autenticadora",
      "verification-code": "Código de Verificación",
      "verification-code-digit": "Dígito {{position}} de {{total}}",
      "verify": "Verificar",
      "manual-key": "Clave de configuración manual",
      "copy-key": "Copiar clave",
      "key-copied": "Clave copiada al portapapeles.",
      "key-copied-button": "Copiado",
      "copy-unavailable": "No fue posible copiar la clave. Cópiela manualmente.",
      "security-recommendations": "Recomendaciones de seguridad",
      "security-recommendations-detail": "Conserve los códigos de recuperación en un lugar seguro y no comparta la clave de configuración."
    },
    "validations": {
      "code": "Código de Verificación es requerido"
    },
    "message": {
      "instruction-1": "Descargue una authenticator app como Microsoft Authenticator para",
      "and": "y",
      "or": "o",
      "for": "para",
      "instruction-2": "Escanee el código QR o introduzca esta llave",
      "instruction-3": "dentro de su authenticator app. Los espacios y separadores no importan.",
      "instruction-4": " Una vez escaneado el código QR o ingresada la llave de arriba, su authentication app le proveerá un código único. Introduzca el código en el campo de confirrmación de abajo."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Códigos de Recuperación",
      "available-once": "Guárdelos ahora: no volverán a mostrarse completos."
    },
    "message": {
      "save-security-codes": "Guarde estos códigos en un lugar seguro.",
      "if-you-lose": "Si pierde su dispositivo y no tiene los códigos de recuperación, perderá acceso a su cuenta."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Generar códigos de recuperación para autenticación con doble factor (2FA)",
      "generate": "Generar Códigos de Recuperación"
    },
    "validations": {},
    "message": {
      "alert-1": "Coloque estos códigos en un lugar seguro.",
      "alert-2": " Si pierde su dispositivo y no tiene los códigos de recuperación, perderá acceso a su cuenta.",
      "alert-3": "Generar nuevos códigos de recuperación no cambia las llaves usadas en el authenticator app. Si desea cambiar la llave usada en el authenticator app, debe",
      "alert-4": " reiniciar su llaves de autenticación."
    }
  },
  "security-login": {
    "title": {
      "login": "Login"
    },
    "label": {
      "username": "Usuario",
      "password": "Contraseña",
      "rememberMe": "Recuérdame",
      "loginButton": "Iniciar sesión ",
      "passwordRecovery": "Recuperar contraseña",
      "notRegistered": "¿ No estas registrado aún ?",
      "signup": "Regístrate",
      "loginAlternative": "o",
      "forgotPassword": "¿ Olvidaste tu contraseña ?",
      "next": "Siguiente",
      "forgotPasswordInstructions": "Ingresa tu usuario y te enviaremos un correo con las instrucciones para recuperar",
      "externalLogin": "Login Externo",
      "captcha-placeholder": "Ingrese Captcha"
    },
    "validations": {
      "usernameRequired": "El campo usuario es requerido",
      "passwordRequired": "La contraseña es requerida",
      "captchaValidationRequired": "Validación de captcha es requerida"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Autenticación de doble factor",
      "login-recovery": "Recuperar codigo de verificación"
    },
    "label": {
      "twoFactorCode": "Codigo autenticador",
      "recoveryCode": "Codigo de recuperación",
      "rememberBrowser": "Recordar este navegador",
      "verificationCodeInstructions": "Ingrese el código de seis dígitos de su aplicación autenticadora para continuar.",
      "loginButton": "Inicio de sesión",
      "loginRecovery": "Inicio de sesión con el codigo de recuperación"
    },
    "message": {
      "no-access": "No tienes acceso a tu dispositivo de autenticación? puedes",
      "trustedBrowser": "Omita la verificación en este navegador de confianza.",
      "recovery-requested": " Ha solicitado iniciar sesión con un código de recuperación. Este inicio de sesión no se recordará hasta que proporcione un código de aplicación de autenticación al iniciar sesión o desactive 2FA y vuelva a iniciar sesión."
    },
    "validations": {
      "twoFactorCode": "El campo codigo autenticación es requerido",
      "recoveryCode": "El campo codigo de recuperación es requerido"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Recuperar contraseña",
      "changePassword": "Cambiar contraseña",
      "userName": "Usuario",
      "newPassword": "Nueva contraseña",
      "repeatPassword": "Repetir contraseña",
      "returnLogin": "Regresar al inicio de sesión "
    },
    "message": {
      "email-sended": "Recuperación de contraseña correo enviado",
      "password-changed": "Se ha cambiado la contraseña satisfactoriamente"
    },
    "validations": {
      "newPassword": "La nueva contraseña debe tener al menos 6 carateres",
      "passwordEqual": "Las contraseña no coinciden"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Instalar authenticator app",
      "reset": "Reiniciar authenticator key",
      "configure": "Configurar authenticator app"
    },
    "validations": {},
    "message": {
      "alert-1": "Si reinicia su llave autenticadora su authenticator app no funcionará hasta que la reconfigure.",
      "alert-2": "Este proceso deshabilita 2FA hasta que verifique su authenticator app.",
      "alert-3": "Si no completa la configuración de su authenticator app podría perder acceso a su cuenta.",
      "success": "Su llave autenticadora ha sido reiniciada, y deberá configurar su authenticator app usando la nueva llave."
    }
  },
  "tfa": {
    "title": {
      "page": "Autenticación con Doble Factor"
    },
    "label": {
      "title": "Autenticación con Doble Factor (2FA)",
      "authenticator-app": "Authenticator app",
      "setup-authenticator": "Configurar authenticator app",
      "add-authenticator": "Añadir authenticator app",
      "reset-authenticator": "Reiniciar authenticator app",
      "reset-recovery-codes": "Reiniciar códigos de recuperación",
      "disable-2fa": "Deshabilitar 2FA",
      "forget-this-browser": "Olvidar este navegador",
      "status-enabled": "Activo",
      "status-disabled": "No configurado",
      "recovery-codes-remaining": "códigos de recuperación disponibles",
      "danger-zone": "Acciones de alto impacto"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Este navegador ha sido olvidado. Cuando haga login nuevamente en este navegador se le solicitará su código 2fa.",
      "no-codes-left-1": "No tiene códigos de recuperación disponibles.",
      "no-codes-left-2": "Debe",
      "no-codes-left-3": "generar un nuevo set de códigos de recuperación",
      "no-codes-left-4": "antes de que pueda hacer login con un código de recuperación.",
      "some-codes-left-1": "Tiene ",
      "some-codes-left-2": "código(s) de recuperación disponible(s).",
      "some-codes-left-3": "Debe ",
      "some-codes-left-4": "generar un nuevo set de códigos de recuperación"
    }
  },
  "roles": {
    "account_reports": "Consulta de Cuentas",
    "catalogs_admin": "Administrador de Catálogos",
    "details_reports": "Detalle de Reportes",
    "environments_admin": "Administrador de Variables de Entorno",
    "forms_admin": "Administrador de Formularios",
    "management_report_admin": "Administrador de Reportes",
    "notifications_admin": "Administrador de Notificaciones",
    "system_auditor": "Auditor de Sistema",
    "taxpayer_reports": "Consultas de Contribuyente",
    "taxpayers_admin": "Administrador de Contribuyentes",
    "payments_admin": "Administrador de Pagos",
    "taxpayers_approver": "Aprobador de Contribuyentes",
    "taxreturn_approver": "Aprobador de Declaraciones",
    "taxreturn_reports": "Consultas de Declaraciones",
    "tfa_admin": "Administrador de 2FA",
    "users_admin": "Administrador de Usuarios",
    "current_account_admin": "Administrador de Cuenta Corriente",
    "debt_collection_analyst": "Analista de cobro",
    "debt_collection_manager": "Gerente de cobro",
    "debt_collection_officer": "Oficial de cobro",
    "taxpayer_communication": "Comunicación al contribuyente",
    "non_compliance_analyst": "Analista de cumplimiento",
    "collection_statistics": "Análisis de cobranza",
    "compliance_statistics": "Análisis de cumplimiento"
  },
  "form-administration": {
    "title": {
      "page": "Administración Formulario para Declaraciones",
      "form": "Formulario",
      "versions": "Versiones"
    },
    "label": {
      "code": "Código",
      "name": "Nombre",
      "shortName": "Nombre corto",
      "tax": "Impuesto",
      "numberModifications": "Número rectificativas",
      "amendmentApprovalRequired": "Rectificativas requieren aprobación",
      "form": "Formulario",
      "versions": "Versiones"
    },
    "header": {
      "actions": "Acciones",
      "code": "Código",
      "name": "Nombre",
      "shortName": "Nombre corto",
      "tax": "Impuesto"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿Estas seguro de eliminarlo?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Casillas",
      "serviceParameters": "Parámetros de Servicio",
      "serviceHeaders": "Cabeceras de Servicio"
    },
    "label": {
      "noFoundCells": "El formulario no tiene celdas definidas",
      "code": "Código Casilla",
      "name": "Nombre Casilla",
      "description": "Descripción",
      "section": "Sección",
      "formula": "Fórmula",
      "order": "Orden",
      "type": "Tipo",
      "service": "Servicio",
      "mandatory": "Obligatorio",
      "editable": "Editable",
      "visible": "Visible",
      "cellPurpose": "Propósito de la celda",
      "numeric": "Numérica",
      "currency": "Moneda",
      "date": "Fecha",
      "list": "Lista",
      "text": "Texto",
      "catalogType": "Tipo Catálogo",
      "parameterName": "Nombre",
      "addParameter": "Agregar Parámetro",
      "headerName": "Nombre",
      "addHeader": "Agregar Cabecera"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿Está seguro de eliminarlo?"
    }
  },
  "form-section": {
    "labels": {
      "description": "Descripción",
      "order": "Orden",
      "code": "Código",
      "sectionType": "Tipo de sección",
      "isMultiple": "Sección múltiple",
      "minInstances": "Instancias mínimas",
      "maxInstances": "Instancias máximas"
    },
    "provisioning": {
      "simple": "Simple",
      "multiple": "Múltiple",
      "jurisdiction": "Jurisdicción"
    }
  },
  "form-version": {
    "title": {
      "page": "Formulario versión ",
      "current-account-rules": "Reglas de Cuenta corriente"
    },
    "labels": {
      "noFoundVersion": "No existe ninguna versión configurada",
      "version": "Versión",
      "formVersion": "Formulario versión",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha Fin",
      "formCode": "Código de formulario",
      "formName": "Nombre del formulario",
      "since": "Desde",
      "generalData": "Información general",
      "fields": "Casillas",
      "sections": "Secciones",
      "enabled": "Habilitada",
      "preview": "Previsualización",
      "current-account-rules": "Reglas de Cuenta corriente",
      "account-type-header": "Tipo de cuenta",
      "transaction-type-header": "Tipo transacción",
      "cell-header": "Casilla",
      "account-type": "Tipo de cuenta",
      "transaction-type": "Tipo transacción",
      "cell": "Casilla"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Previsualizar",
      "year": "Periodo",
      "taxpayer": "Identificador de contribuyente",
      "nit": "Ruc",
      "taxpayerName": "Nombre de contribuyente",
      "validTestTaxpayer": "No se ha encontrado el Contribuyente especificado",
      "validTestTax": "Contribuyente no cuenta con impuesto relacionado a este formulario",
      "formulaLog": "Log de Fórmulas"
    },
    "messages": {
      "formVersionNotFound": "La versión del formulario no fue encontrada",
      "taxReturnExist": "La declaración ya existe para este período"
    }
  },
  "taxes": {
    "title": {
      "page": "Administrar Impuestos"
    },
    "label": {
      "name": "Nombre",
      "rateType": "Tipo Tasa",
      "shortName": "Nombre corto",
      "code": "Código",
      "newButton": "Nuevo",
      "saveButton": "Guardar",
      "tabEditTax": "General",
      "tabRates": "Tasas",
      "rate": "Tasa",
      "tabPeriodicity": "Periodicidad",
      "tabOperations": "Operaciones",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "value": "Valor",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración",
      "paymentDueDay": "Dia de pago"
    },
    "header": {
      "code": "Código",
      "name": "Nombre",
      "rateType": "Tipo Tasa",
      "value": "Valor",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "shortName": "Nombre corto",
      "actions": "Acciones",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración"
    },
    "validations": {
      "rate TypeRequired": "El campo tipo de tasa es requerido",
      "shortNameRequired": "El campo nombre corto es requerido",
      "codeRequired": "El campo código es requerido",
      "valueLessThan100": "El campo valor debe ser menor al 100%",
      "valueRequired": "El campo valor es requerido",
      "dateFromRequired": "El campo fecha desde es requerido",
      "dateToRequired": "El campo fecha hasta es requerido",
      "filingDueDayRequired": "El campo día expiración es requerido",
      "periodicityTypeRequired": "El campo tipo periodicidad es requerido"
    },
    "messages": {
      "savedSuccessfully": "Se guardó correctamente",
      "deletedSuccessfully": "Se eliminó correctamente",
      "error": "Error"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Administrar Operaciones Informes",
      "warning": "Advertencia"
    },
    "label": {
      "operation": "Operación",
      "report": "Informe"
    },
    "header": {
      "operation": "Operación",
      "report": "Informe",
      "actions": "Acciones"
    },
    "messages": {
      "removeReportOperation": "¿Estas seguro de eliminarlo?"
    }
  },
  "reports": {
    "title": {
      "page": "Administrar Informes",
      "report": "Informe",
      "versions": "Versiones"
    },
    "label": {
      "name": "Nombre",
      "rateType": "Tipo Tasa",
      "shortName": "Nombre corto",
      "code": "Código",
      "newButton": "Nuevo",
      "saveButton": "Guardar",
      "tabEditReport": "General",
      "tabPeriodicity": "Periodicidad",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración"
    },
    "header": {
      "code": "Código",
      "name": "Nombre",
      "shortName": "Nombre corto",
      "actions": "Acciones",
      "dateFrom": "Fechas desde",
      "dateTo": "Fecha hasta",
      "periodicityType": "Tipo periodicidad",
      "filingDueDay": "Día expiración"
    },
    "validations": {
      "shortNameRequired": "El campo nombre corto es requerido",
      "codeRequired": "El campo código es requerido",
      "dateFromRequired": "El campo fecha desde es requerido",
      "dateToRequired": "El campo fecha hasta es requerido",
      "filingDueDayRequired": "El campo día expiración es requerido",
      "periodicityTypeRequired": "El campo tipo periodicidad es requerido"
    },
    "messages": {
      "savedSuccessfully": "Se guardó correctamente",
      "deletedSuccessfully": "Se eliminó correctamente",
      "error": "Error"
    }
  },
  "report-cells": {
    "title": {
      "page": "Casillas"
    },
    "label": {
      "code": "Código Casilla",
      "name": "Nombre Casilla",
      "description": "Descripción",
      "formula": "Fórmula",
      "order": "Orden",
      "type": "Tipo",
      "numeric": "Numérica",
      "currency": "Moneda",
      "date": "Fecha",
      "list": "Lista",
      "text": "Texto",
      "catalogType": "Tipo Catálogo",
      "mandatory": "Obiligatorio"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿Está seguro que desea eliminarlo?"
    }
  },
  "report-version": {
    "title": {
      "page": "Informe versión "
    },
    "label": {
      "version": "Versión",
      "formVersion": "Informe versión",
      "startDate": "Fecha desde",
      "endDate": "Fecha hasta",
      "formCode": "Código",
      "formName": "Nombre",
      "since": "Desde",
      "tabVersion": "Versión",
      "fields": "Casillas"
    },
    "messages": {
      "confirmTitle": "Eliminar",
      "confirmDeleted": "¿Estas seguro de eliminarlo?"
    }
  },
  "taxOperation": {
    "title": {
      "page": "Administrar Operaciones Impuestos",
      "warning": "Advertencia"
    },
    "label": {
      "operation": "Operación",
      "tax": "Impuesto"
    },
    "header": {
      "operation": "Operación",
      "tax": "Impuesto",
      "actions": "Acciones"
    },
    "messages": {
      "removeTaxOperation": "¿Estas seguro de eliminarlo?",
      "allOperationsLinked": "Todas las operaciones ya están vinculadas a este impuesto",
      "noLinkedOperations": "No hay operaciones vinculadas a este impuesto"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Cuenta corriente",
      "amendingCredit": "Consulta de saldo",
      "currentAccountTransaction": "Detalle de transacciones",
      "transactionAdjustment": "Ajuste de saldo"
    },
    "label": {
      "nit": "Ruc",
      "tax": "Impuesto",
      "taxCode": "Cod. Impuesto",
      "period": "Periodo",
      "taxAmount": "Monto de impuesto",
      "penalty": "Multa",
      "interest": "Intereses",
      "taxArrears": "Mora",
      "total": "Total",
      "expirationDate": "Fecha Vencimiento",
      "accountType": "Tipo de cuenta",
      "balance": "Saldo",
      "date": "Fecha",
      "transactionType": "Tipo de transacción",
      "value": "Valor",
      "document": "Documento",
      "taxpayerName": "Nombre",
      "credit": "Crédito",
      "debit": "Débito"
    },
    "dialog": {},
    "messages": {},
    "validations": {
      "nit-required": "Ruc es requerido"
    }
  },
  "taxpayer-payments": {
    "title": {
      "page": "Consulta de pagos",
      "paymentsByJurisdiction": "Pagos por jurisdicción",
      "pagePayments": "Registro de pago",
      "pageUploadPayments": "Carga de pagos",
      "selectTaxReturn": "Seleccione Declaración de impuestos",
      "reconciliationPayments": "Conciliación de pagos",
      "paymentsTaxpayer": "Pagos reportados por el contribuyente",
      "paymentsTaxCollect": "Pagos informados por la entidad recaudadora",
      "concialiation": "Conciliación",
      "checkBankInformation": "Consultar información bancaria"
    },
    "label": {
      "registerPayment": "Registro de pago",
      "amountTaxReturn": "Monto de la declaración",
      "totalDebt": "Deuda total",
      "amountTaxpayer": "Monto contribuyente",
      "amountBank": "Monto banco",
      "amountFrom": "Monto desde",
      "amountTo": "Monto hasta",
      "tax-id": "Ruc",
      "name": "Nombre",
      "date-from": "Fecha desde",
      "date-to": "Fecha hasta",
      "date-payment": "Fecha pago",
      "payment-number": "Número de pago",
      "exchange-rate": "Tipo de cambio",
      "local-amount": "Monto en moneda local",
      "tax": "Impuesto",
      "amount": "Monto",
      "excelDefinition": "Definición de archivo de excel",
      "taxCollector": "Entidad recaudadora",
      "swiftNumber": "Número de confirmación SWIFT",
      "uploadNumber": "Número de carga",
      "hasErrors": "Tiene errores",
      "date-payment-bank": "Fecha recibido"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Pago registrado satisfactoriamente el [createDate]",
      "diferentCurrencyCode": "No se puede conciliar pagos de moneda diferente",
      "exceedsTolerance": "Excede la tolerancia de [tolerence]% permitida",
      "paymentGreaterThen": "Pagos reportados por el contribuyente son mayores que el pago informado por la entidad recaudadora"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Consulta de contribuyentes"
    },
    "label": {
      "name": "Nombre",
      "nit": "RUC",
      "county": "País",
      "personType": "Tipo de persona",
      "email": "Correo"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Tipo persona",
      "businessName": "Nombre o razón social",
      "fullName": "Nombre completo",
      "id": "Número de identificación",
      "taxNumber": "Número de identificación tributaria en el país de residencia",
      "phoneNumber": "Número de teléfono",
      "domicile": "Domicilio",
      "department": "Departamento/Provincia/Estado",
      "addContact": "Añadir contacto",
      "operations": "Operaciones",
      "contacts": "Contactos",
      "taxVector": "Vector fiscal",
      "reportVector": "Reportes",
      "generalData": "Generales",
      "tax": "Impuesto",
      "taxObligation": "Impuesto",
      "report": "Reporte",
      "website": "Sitio web",
      "idTax": "Número de identificación tributario en el país de residencia",
      "contactName-tax": "Nombre del contacto principal",
      "docNumberContact-tax": "Número de identificación del contacto",
      "contactTaxIdNumber-tax": "Número de identificación tributario del contacto en el país de residencia",
      "phoneNumberContact-tax": "Número de teléfono del contacto en el país de residencia",
      "email-tax": "Correo del contacto",
      "documents": "Documentos",
      "docCompanyRegistrationNumber": "Documento de registro de la empresa",
      "docLocalContact": "Documento de identidad del contacto en el país de residencia",
      "acceptance": "Aceptación",
      "taxpayerRequest": "Registro en POSS",
      "confirmTerms": "Aceptar términos y condiciones",
      "terms": "Lorem ipsum dolor sit amet consectetur adipiscing elit per, penatibus euismod ac libero praesent sollicitudin lacinia nulla platea, nam hac cursus cubilia congue luctus dapibus. Iaculis luctus egestas accumsan eleifend metus dis aptent quisque, lacus vitae nullam habitasse ad mollis tempor, mattis ornare dapibus laoreet auctor tellus dui. Ante integer sagittis erat accumsan vulputate potenti senectus, rutrum ullamcorper nam hendrerit ridiculus faucibus, parturient fames ligula venenatis tristique inceptos.\n\nCum aliquet tempor cras non potenti inceptos aptent, mauris scelerisque mollis auctor libero porta id ut, sodales vulputate eget imperdiet netus posuere. Iaculis dignissim himenaeos magna luctus nulla egestas porttitor, eros vulputate volutpat sociosqu quisque mollis donec, class placerat justo vivamus imperdiet accumsan. Ultrices facilisi phasellus augue cursus etiam viverra suspendisse est, nam vulputate tempor posuere dignissim feugiat sed hac sodales, diam tristique pretium auctor ad erat sem. Et enim gravida magnis malesuada nam nascetur fermentum, proin platea elementum nec penatibus ultricies, blandit cubilia aptent neque praesent sociis.\n\nSagittis augue enim nam sociis, ornare est mi himenaeos, risus proin sodales. Proin malesuada integer aliquam cubilia neque natoque velit, feugiat elementum quis quisque suscipit fermentum conubia, nisi a ligula duis sapien tellus. Praesent mattis fringilla habitant nulla sollicitudin bibendum habitasse at cum quis mus iaculis mi magna sodales, velit hendrerit inceptos dictum neque montes turpis tellus nam morbi commodo nullam senectus.\n\nArcu primis eu conubia fusce nisi vehicula posuere leo sollicitudin eleifend, phasellus sodales congue ligula consequat volutpat magnis facilisi curabitur maecenas, et dis velit libero hac proin habitant sociis nascetur. Nunc tortor penatibus mi ultrices risus nec elementum justo, mattis ad ac tempus vel habitasse accumsan sed parturient, lectus lacinia conubia malesuada volutpat egestas nulla. Himenaeos consequat vitae class mattis taciti nec habitant eleifend, elementum netus eget parturient suspendisse porttitor in felis maecenas, curabitur morbi odio gravida vivamus per bibendum.\n\nTortor non sociosqu accumsan orci vel ligula risus nisl, penatibus odio magnis ullamcorper pellentesque habitant lacinia consequat, aptent nec congue nisi egestas sociis quam. Turpis sociis eu est parturient in fames aliquet nisl, dui natoque phasellus aliquam posuere curae aptent porta, tortor condimentum molestie netus cubilia inceptos lacinia. Auctor laoreet purus nostra dapibus sollicitudin tincidunt dictum nisl lacinia erat, est rhoncus fusce phasellus blandit etiam inceptos suspendisse magna, duis pellentesque nam hac neque mus dignissim a enim.\n\nNeque proin felis laoreet senectus nullam netus sollicitudin odio tincidunt, penatibus parturient facilisis porta duis sagittis malesuada varius sociosqu congue, aptent velit pellentesque mauris egestas nibh semper orci. Dis sociosqu at torquent nec commodo erat eu pharetra natoque, senectus velit nascetur curae sollicitudin mus phasellus. Aenean diam ut nibh vulputate neque fusce penatibus class porta mattis imperdiet risus ante, ac lectus habitasse posuere facilisis luctus varius mus tempus non mollis.\n\nDictumst eleifend vehicula purus hendrerit volutpat primis integer, per senectus fusce nulla cubilia dictum feugiat auctor, ultricies sociosqu nisl mi class magnis. Ligula himenaeos phasellus pulvinar accumsan platea egestas sodales hendrerit sagittis augue, curae nec molestie pretium cum parturient lacus euismod sociosqu ullamcorper duis, dignissim fusce libero maecenas congue lobortis penatibus nisi justo.\n\nCum rutrum vehicula convallis pellentesque maecenas nascetur proin congue platea, posuere neque facilisi ullamcorper nibh curae sodales non, cursus nisl cras morbi interdum vitae auctor cubilia. Ligula taciti enim donec congue bibendum fusce eros rhoncus suscipit, dui parturient potenti odio sapien non erat eget, tincidunt convallis primis quam tortor consequat sodales per. Neque hendrerit erat nunc hac ullamcorper molestie fermentum, tristique ultrices sociis vivamus volutpat lectus, vestibulum vehicula aenean mattis magna posuere. Justo condimentum tempor taciti laoreet inceptos per hendrerit eleifend consequat lacus nostra enim, convallis praesent dui faucibus lobortis quam pharetra odio mauris duis.\n\nMagna ultrices dui netus laoreet odio rhoncus maecenas nec placerat rutrum, massa duis nam nulla velit quis fringilla habitasse. Eu integer diam lectus ullamcorper torquent ante aliquet cras feugiat inceptos placerat ut, porta libero nam mauris volutpat habitasse iaculis lacinia facilisi hendrerit nostra.\n\nLaoreet risus nisi sociosqu inceptos maecenas blandit phasellus bibendum, nostra velit fringilla tristique mus donec lectus semper, est tortor nascetur curae scelerisque himenaeos sagittis. Quam volutpat eros non nec nascetur justo, velit tristique nisl arcu est, ultricies sapien convallis metus vulputate. Condimentum justo ad varius habitant nunc gravida sed vivamus, maecenas ut congue aenean ligula proin lectus, natoque urna duis dui semper egestas habitasse.\n\nAnte et luctus porta malesuada accumsan cursus senectus dictumst penatibus pretium nullam, id condimentum proin felis aliquam sollicitudin varius velit lobortis class placerat, praesent ridiculus eget nisl metus tristique maecenas semper himenaeos parturient. Enim laoreet vulputate orci dui lectus purus bibendum vivamus posuere est curabitur, cubilia fames nulla porta in scelerisque cursus nunc a ligula pretium dictum, mi molestie pulvinar torquent litora vitae fusce eget curae sem. Dapibus quam facilisi cras pharetra mus curabitur, parturient a malesuada integer vitae etiam suspendisse, fermentum massa libero curae neque.",
      "locale": "Lenguaje predefinido",
      "queryOfRequest": "Consulta de solicitud",
      "acquirerId": "Identificación del adquirente",
      "acquirerCountry": "País del adquirente",
      "terminalId": "Identificación del terminal",
      "merchantCategoryCode": "Código de categoría del comerciante",
      "merchantId": "Identificación del comerciante",
      "documentNumberCountryResidence": "Número de documento en el país de residencia"
    },
    "vector": {
      "label": {
        "tax": "Impuesto",
        "expiration": "Dia de expiración",
        "periodicity": "Periodicidad",
        "startOperation": "Inicio de  operación"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Al menos un contacto es requerido",
      "operations": "Al menos una operación es requerida ",
      "selectOperations": "Operaciones asociadas",
      "withoutOperations": "Sin operaciones",
      "withoutOperationsVector": "No tiene Impuestos asociados",
      "withoutOperationsReport": "No tiene Reportes asociados",
      "withoutDocuments": "No existe ninguna definición de archivos"
    },
    "validations": {
      "acceptance": "Campo debe ser seleccionado",
      "formComplete": "Completa todo el formulario"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Solicitudes de Contribuyentes",
      "approve": "Aprobar Solicitud",
      "reject": "Rechazar Solicitud",
      "request-additional-info": "Solicitar Información Adicional",
      "request": "Solicitud"
    },
    "label": {
      "check-digit": "Dígito verificador",
      "date-from": "Fecha Desde",
      "date-to": "Fecha Hasta",
      "request-type": "Tipo de Solicitud",
      "request": "Solicitud",
      "type": "Tipo",
      "taxpayer": "Contribuyente",
      "state": "Estado",
      "approve": "Aprobar",
      "reject": "Rechazar",
      "request-additional-info": "Devolver",
      "comments": "Comentarios",
      "reason": "Causa",
      "createdDate": "Fecha",
      "cancellationDate": "Fecha de cancelación"
    },
    "message": {
      "approved": "Solicitud Aprobada",
      "rejected": "Solicitud Rechazada",
      "periodictyOutOfDate": "Una periodicidad de impuesto o reportes no esta vigente"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Consulta Declaraciones"
    },
    "label": {
      "nit": "Ruc",
      "taxreturnNumber": "Número Declaración",
      "country": "País",
      "formId": "Formulario",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "name": "Nombre Contribuyente",
      "period": "Periodo",
      "periodFrom": "Fecha Desde",
      "periodTo": "Fecha Hasta",
      "active": "Activa"
    },
    "header": {
      "actions": "Acciones",
      "nit": "Ruc",
      "name": "Nombre Contribuyente",
      "taxReturnNumber": "Número Declaración",
      "createDate": "Fecha",
      "taxreturnType": "Tipo Declaración",
      "taxreturnStatus": "Estado",
      "form": "Formulario",
      "period": "Periodo",
      "active": "Activa"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Actualizar registro"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Darse de Baja"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "Enviar mensaje"
    },
    "label": {
      "nit": "NIT",
      "taxpayerName": "Nombre",
      "subject": "Asunto",
      "message": "Mensaje"
    }
  },
  "appMenu": {
    "audit-log-application-http": "Log de peticiones http de aplicación",
    "audit-log-security-http": "Log de peticiones http seguridad",
    "catalog": "Catálogos",
    "collection_compliance": "Recaudación y cumplimiento",
    "collection_statistics": "Estadística de Cobranza",
    "compliance_statistics": "Estadística de Cumplimiento",
    "configuration": "Configuraciones",
    "configure_penalties": "Configuración de penalidades",
    "debt_collection_manage": "Ver procesos",
    "disable-tfa-to-user": "Deshabilitar Doble Factor de Autenticación (2FA)",
    "economy-activity": "Operaciones",
    "environment-application": "Variables de Aplicación",
    "environment-security": "Variables de Seguridad",
    "home-template": "Plantilla pantalla inicio",
    "manage-form": "Formularios",
    "manage-report-operations": "Operaciones Informes Complementarios",
    "manage-report": "informes Complementarios",
    "manage-tax-operations": "Operaciones Impuestos",
    "manage-tax": "Impuestos",
    "management-report-payment": "Pagos",
    "management-report-taxpayer": "Contribuyentes",
    "management-report-taxreturn": "Declaraciones",
    "management-report": "Reportes gerenciales",
    "non_compliance": "Control de Cumplimiento",
    "notifications-application": "Notificaciones Aplicación",
    "notifications-security": "Notificaciones Seguridad",
    "operations": "Operaciones",
    "query-payments-taxofficer": "Consultar pagos",
    "report-details": "Consultar informes Complementarios",
    "reports": "Reportes",
    "security": "Seguridad",
    "send-message-taxpayer": "Enviar mensaje",
    "statements-tax-officer": "Declaraciones",
    "tax-official-query-amending-credit": "Cuenta corriente",
    "taxes": "Impuestos",
    "taxofficer-check-load-payments": "Consultar información bancaria",
    "taxofficer-payment-record": "Registro de pago",
    "taxofficer-reconciliation-payments": "Conciliación de pagos",
    "taxofficer-taxreturn-payments": "Pagos",
    "taxofficer-transaction-adjustment": "Ajuste de saldo",
    "taxofficer-upload-payments": "Subir información bancaria",
    "taxpayer-feedback": "Comentarios",
    "taxpayer-fields": "Campos Contribuyente",
    "taxpayer-report": "Consulta de contribuyente",
    "taxpayer-requests": "Solicitudes de Contribuyentes",
    "taxpayers": "Contribuyentes",
    "taxreport-report": "Consultar declaraciones",
    "taxreturn-evaluation": "Revisión de Rectificativas",
    "terms-template": "Plantilla Terminos y Condiciones",
    "two-factor-authentication": "Autenticación con Doble Factor",
    "user-taxpayers": "Contribuyentes",
    "users": "Usuarios"
  }
}
